import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {http} from 'hiya-common/src/utils/axios'

// 象神节领取奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96437796
export const elephant_god_put = createAsyncThunk(
  'elephant_god_put',
  async (arg: {type: number; process: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'status' | 'reward_desc' | 'reward_list' | 'err_msg'
        >
      >
    >(
      '/live/activity/elephant_god_put',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    const {err_msg = ''} = resp.data.data
    if (err_msg) {
      onlyToast(err_msg)
    }
    return resp.data.data
  }
)

interface AwardType {
  pic: string
  desc: string
}

interface InitialStateType {
  // 奖励获取
  status: number
  reward_desc: string
  reward_list: Array<AwardType>
  err_msg?: string
}

const initialState: InitialStateType = {
  reward_list: [],
  reward_desc: '',
  status: 0,
}

export const ElephantModalSlice = createSlice({
  name: 'ElephantModalSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(elephant_god_put.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default ElephantModalSlice.reducer
export const ElephantModalActions = ElephantModalSlice.actions
